import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteBillRequestForm.NetSuiteBillFieldsSection', {
    vendorDetailsSectionName: 'Vendor details',
    billDetailsSectionName: 'Bill details',
    memoSectionName: 'Memo',
    textFieldPlaceholder: 'Enter value',
    nsVendorBillingAddress: 'Billing address',
    nsVendorBillingAddressPlaceholder: 'Select address',
    nsVATRegistration: 'VAT registration',
    nsTransactionNumberFieldText: 'Transaction number',
    nsReferenceFieldText: 'Reference',
    nsExchangeRateFieldText: 'Exchange rate',
    nsVendorFieldText: 'Vendor',
    nsVendorFieldPlaceholder: 'Select vendor',
    nsPaymentHoldFieldText: 'Payment hold',
    nsPaymentHoldYes: 'Yes',
    nsDiscountAmountFieldText: 'Discount amount',
    nsDiscountDateFieldText: 'Discount date',
    nsDueDateFieldText: 'Due date',
    nsDueDateFieldPlaceholder: 'Select due date',
    nsDateFieldText: 'Date',
    nsDateFieldPlaceholder: 'Select date',
    nsPostingPeriodFieldText: 'Posting period',
    nsTermsFieldText: 'Terms',
    nsTermsFieldPlaceholder: 'Select terms',
    nsAccountFieldText: 'Account',
    nsAccountFieldPlaceholder: 'Select account',
    nsDepartmentFieldText: 'Department',
    nsDepartmentFieldPlaceholder: 'Select department',
    nsClassFieldText: 'Class',
    nsClassFieldPlaceholder: 'Select class',
    nsLocationFieldText: 'Location',
    nsLocationFieldPlaceholder: 'Select location',
    newVendor: '+ New Vendor',
    multipleVendorsWarning: 'Multiple vendors detected. Check suggested vendors.',
    earlyDueDateWarning: 'Due date is earlier than the Date.',
    multipleDepartmentsWarning: 'Vendor bills had multiple departments in the past. Check suggested departments.',
});
